export default __webpack_public_path__ + "static/media/internetkill.ca454c63.jpg";